import { Stack, Typography } from "@mui/material";
import { KbFileSection, KbFolderSection } from "./KbSection";
import { useGetAllKbRecords, useGetKbRecentlyViewed } from "controller";
import { useAtomValue } from "jotai";
import {
  centralFolderList,
  centralFolderTreeNodes,
  customerFolderList,
  filtersObj,
  searchQueryStr,
  sortColumnAStr,
  sortDirectionStr,
} from "../store";
import { filterData, generateKbFilesAndFolders } from "../helpers";
import { CircularLoader } from "components";
import { KbSearch } from "./KbSearch";
import { useMemo } from "react";
import { KbNoDataScreen } from "./KbNoDataScreen";

export const KbCentralKb = () => {
  const searchQuery = useAtomValue(searchQueryStr);
  const sortColumn = useAtomValue(sortColumnAStr);
  const sortDirection = useAtomValue(sortDirectionStr);
  const filters = useAtomValue(filtersObj);

  const transformedFilters = [
    ...(filters?.date_created
      ? [
          {
            column: "kb_records.created_at",
            operator: "=",
            value: filters?.date_created,
          },
        ]
      : []),
    ...(filters?.last_modified
      ? [
          {
            column: "kb_records.updated_by",
            operator: "=",
            value: filters?.last_modified,
          },
        ]
      : []),
    ...(filters?.created_by
      ? [
          {
            column: "kb_records.owner_id",
            operator: "=",
            value: filters?.created_by,
          },
        ]
      : []),
  ];

  const centralFolders = useAtomValue(centralFolderList);

  const allFolders = useMemo(() => {
    return filterData({
      filters,
      kbData: [...(centralFolders[0]?.children || [])],
    });
  }, [centralFolders]);

  const { files, folders } = generateKbFilesAndFolders(
    // @ts-ignore
    allFolders || [],
  );
  return (
    <Stack sx={{ height: "100%" }}>
      <Typography variant="body-xsmall"></Typography>
      <KbSearch />
      {!allFolders ? (
        <Stack
          direction={"row"}
          sx={{
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularLoader />
        </Stack>
      ) : (
        <>
          {folders && folders.length > 0 && (
            <KbFolderSection title="Folders" folders={folders} />
          )}
          {files && files.length > 0 && (
            <KbFileSection isSelectable files={files || []} />
          )}
          {(!folders || (folders && folders?.length === 0)) &&
            (!files || files?.length === 0) && <KbNoDataScreen />}
        </>
      )}
    </Stack>
  );
};
